module.exports = __webpack_public_path__ + "9cfc554b8756ac7d96b08c7ef44d12b7.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-74.png
// module id = 143
// module chunks = 0